"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACTIVATES = exports.RELEASES = exports.STRESSES = exports.MOVEMENT_PATTERNS = exports.BARE_CUSTOM_EXERCISE = exports.BREAK_EXERCISE = exports.BARE_EXERCISE_ENTRY = void 0;
exports.BARE_EXERCISE_ENTRY = {
    docId: '',
    description: '',
    movementPattern: '',
    intensity: 1,
    stress: [],
    releases: [],
    activates: [],
    equipment: [],
    optionalEquipment: [],
    title: '',
    name: '',
    cues: [],
    duration: 0,
    published: true,
    prenatalVideo: {},
    postnatalVideo: {},
    prenatalThumb: {},
    postnatalThumb: {},
    instructionVideo: {},
    instructionThumb: {},
    archived: false,
    metadata: null,
    preComposited: false
};
exports.BREAK_EXERCISE = Object.assign(Object.assign({}, exports.BARE_EXERCISE_ENTRY), { isBreak: true, name: 'break', duration: 30 });
exports.BARE_CUSTOM_EXERCISE = Object.assign(Object.assign({}, exports.BARE_EXERCISE_ENTRY), { isCustom: true, duration: 60 });
exports.MOVEMENT_PATTERNS = [
    'warm-up/release',
    'warm-up/mobility',
    'warm-up/activate',
    'hinge',
    'squat',
    'lunge',
    'rotation',
    'push',
    'pull',
    'carry',
    'core'
];
exports.STRESSES = [
    'unilateralLowerBody',
    'twistingRotation',
    'highPressure',
    'verticalPush',
    'horizontalPush',
    'cSectionTug',
    'lateral',
    'notPreNatal',
    'notFirst6PostNatal',
    'notPostNatal'
];
exports.RELEASES = [
    'glutes',
    'pelvicFloor',
    'midBack',
    'adductor',
    'chest',
    'quads',
    'hips',
    'shoulder',
    'calves',
    'lats'
];
exports.ACTIVATES = [
    'glutes',
    'gluteMed',
    'pelvicFloor',
    'adductor',
    'tva',
    'midBack',
    'breath',
    'pushBreath'
];
//# sourceMappingURL=exerciseModel.js.map